/**
 * FINANCIAL NAV - Reusable navigation tabs for financial pages
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function FinancialNav() {
  const location = useLocation();

  const navItems = [
    { path: '/admin/financials', label: 'Dashboard', exact: true },
    { path: '/admin/financials/explorer', label: 'Cost Explorer' },
    { path: '/admin/financials/unit-economics', label: 'Unit Economics' },
    { path: '/admin/financials/invoices', label: 'Invoices' },
    { path: '/admin/financials/runway', label: '🛟 Runway' },
    { path: '/admin/financials/rates', label: '💰 Rate Management' }
  ];

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <div className="mb-8 bg-white rounded-lg shadow p-2 flex flex-wrap gap-2">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`px-4 py-2 rounded-md font-medium transition-colors ${
            isActive(item)
              ? 'bg-blue-600 text-white'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
}
